import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { default as apiFunctions, getAPIURL } from '@utils/api'

export const usePayrollConfig = () => {
  const queryClient = useQueryClient()
  const api = useApi({ baseURLOverride: getAPIURL() })

  const usePayrollConfigQuery = () =>
    useQuery({ queryKey: ['payrollConfigQuery'], queryFn: () => api.post('payroll/pay_config') })

  const useSpecialPayConfigQuery = (filter) =>
    useQuery({
      queryKey: ['specialPayConfigQuery', filter],
      queryFn: () => api.post('payroll/special_pay/overview', { filter }),
    })

  const useUploadSpecialPayConfigs = () =>
    useMutation({
      mutationKey: ['uploadSpecialPayConfig'],
      mutationFn: apiFunctions.uploadSpecialPayConfig,
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['specialPayConfigQuery'],
        })
      },
    })

  const useUploadAutomaticPayConfigs = () =>
    useMutation({
      mutationKey: ['uploadAutomaticPayConfig'],
      mutationFn: apiFunctions.uploadPayrollConfigs,
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: ['payrollConfigQuery'],
        })
      },
    })

  return { usePayrollConfigQuery, useSpecialPayConfigQuery, useUploadSpecialPayConfigs, useUploadAutomaticPayConfigs }
}
